import { AbortError } from "utils/errors/abortError";

import { apiReq, type TBody, type TMethod, type TOptions, type TResult } from "./apiReq";
import { isAbortError } from "./isAbortError";

const requests = new Map<string, AbortController[]>();

// Make sure you catch the error / use ignoreAbortError to handle the error
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function apiReqAbortOld<T = any>({
  body = null,
  key,
  method,
  options = {},
  path,
  wrapAbortError = true,
}: {
  body?: TBody;
  key: string;
  method: TMethod;
  options?: TOptions;
  path: string;
  wrapAbortError?: boolean;
}): Promise<TResult<T>> {
  if (!requests.has(key)) requests.set(key, []);
  requests.get(key)?.forEach((controller) => controller.abort());

  const controller = new AbortController();
  requests.get(key)?.push(controller);
  try {
    const response = await apiReq(method, path, body, { ...options, abortSignal: controller.signal, noCache: true });
    requests.get(key)?.splice(requests.get(key)!.indexOf(controller), 1);
    return response;
  } catch (error) {
    requests.get(key)?.splice(requests.get(key)!.indexOf(controller), 1);
    if (wrapAbortError && isAbortError(error)) {
      throw new AbortError("Request aborted");
    }
    throw error;
  }
}
